import { pageMetadataFields } from '@/data/sanity/fragments/_shared'
import cmsSettings from '../cmsSettings'

export const fields = `
  _type,
  _id,
  ${cmsSettings()},
  sectionBackground,
  headline,
  dishes[]-> {
    ${pageMetadataFields}
  }
`

export const fragment = (name = 'featureSpotlight') => `${name}{ ${fields} }`

const exported = {
  fields,
  fragment,
}

export default exported
